import type { GamePlatform } from '../schemas/game.js';

// Canonical render order for platform UI (toggle pills, per-platform sections).
export const GAME_PLATFORM_ORDER: readonly GamePlatform[] = [
  'pc',
  'mac',
  'linux',
  'ios',
  'android',
  'console',
  'vr',
] as const;

export const GAME_PLATFORM_LABELS: Readonly<Record<GamePlatform, string>> = {
  pc: 'PC',
  mac: 'Mac',
  linux: 'Linux',
  ios: 'iOS',
  android: 'Android',
  console: 'Console',
  vr: 'VR',
};
